module.exports = __webpack_public_path__ + "static/media/bmp-logo.1015ce9a.png";